/** Lat/lon + country code for common IATA airports */
interface AirportCoord {
  lat: number;
  lon: number;
  country: string; // ISO 3166-1 alpha-2
}

const COORDS: Record<string, AirportCoord> = {
  // Europe
  FRA: { lat: 50.033, lon: 8.571, country: 'DE' },
  MUC: { lat: 48.354, lon: 11.786, country: 'DE' },
  TXL: { lat: 52.560, lon: 13.288, country: 'DE' },
  BER: { lat: 52.362, lon: 13.509, country: 'DE' },
  HAM: { lat: 53.630, lon: 9.988, country: 'DE' },
  DUS: { lat: 51.289, lon: 6.767, country: 'DE' },
  CGN: { lat: 50.866, lon: 7.143, country: 'DE' },
  STR: { lat: 48.690, lon: 9.222, country: 'DE' },
  LHR: { lat: 51.470, lon: -0.454, country: 'GB' },
  LGW: { lat: 51.148, lon: -0.190, country: 'GB' },
  STN: { lat: 51.885, lon: 0.235, country: 'GB' },
  LTN: { lat: 51.875, lon: -0.368, country: 'GB' },
  MAN: { lat: 53.354, lon: -2.275, country: 'GB' },
  EDI: { lat: 55.950, lon: -3.373, country: 'GB' },
  CDG: { lat: 49.010, lon: 2.548, country: 'FR' },
  ORY: { lat: 48.723, lon: 2.379, country: 'FR' },
  NCE: { lat: 43.658, lon: 7.216, country: 'FR' },
  LYS: { lat: 45.726, lon: 5.091, country: 'FR' },
  AMS: { lat: 52.309, lon: 4.764, country: 'NL' },
  MAD: { lat: 40.472, lon: -3.561, country: 'ES' },
  BCN: { lat: 41.297, lon: 2.078, country: 'ES' },
  PMI: { lat: 39.552, lon: 2.739, country: 'ES' },
  AGP: { lat: 36.675, lon: -4.499, country: 'ES' },
  FCO: { lat: 41.800, lon: 12.239, country: 'IT' },
  MXP: { lat: 45.630, lon: 8.723, country: 'IT' },
  VCE: { lat: 45.505, lon: 12.352, country: 'IT' },
  NAP: { lat: 40.886, lon: 14.291, country: 'IT' },
  ZRH: { lat: 47.458, lon: 8.548, country: 'CH' },
  GVA: { lat: 46.238, lon: 6.109, country: 'CH' },
  VIE: { lat: 48.110, lon: 16.570, country: 'AT' },
  CPH: { lat: 55.618, lon: 12.656, country: 'DK' },
  OSL: { lat: 60.194, lon: 11.100, country: 'NO' },
  ARN: { lat: 59.652, lon: 17.919, country: 'SE' },
  HEL: { lat: 60.318, lon: 24.963, country: 'FI' },
  LIS: { lat: 38.781, lon: -9.136, country: 'PT' },
  DUB: { lat: 53.422, lon: -6.270, country: 'IE' },
  BRU: { lat: 50.902, lon: 4.484, country: 'BE' },
  WAW: { lat: 52.166, lon: 20.967, country: 'PL' },
  PRG: { lat: 50.101, lon: 14.260, country: 'CZ' },
  BUD: { lat: 47.437, lon: 19.262, country: 'HU' },
  OTP: { lat: 44.572, lon: 26.102, country: 'RO' },
  ATH: { lat: 37.936, lon: 23.947, country: 'GR' },
  IST: { lat: 41.275, lon: 28.752, country: 'TR' },
  SAW: { lat: 40.898, lon: 29.309, country: 'TR' },
  AYT: { lat: 36.899, lon: 30.800, country: 'TR' },
  KBP: { lat: 50.345, lon: 30.895, country: 'UA' },
  SVO: { lat: 55.973, lon: 37.413, country: 'RU' },
  DME: { lat: 55.409, lon: 37.906, country: 'RU' },
  LED: { lat: 59.800, lon: 30.263, country: 'RU' },
  KEF: { lat: 63.985, lon: -22.606, country: 'IS' },

  // Middle East
  DXB: { lat: 25.253, lon: 55.366, country: 'AE' },
  AUH: { lat: 24.433, lon: 54.651, country: 'AE' },
  SHJ: { lat: 25.329, lon: 55.517, country: 'AE' },
  DOH: { lat: 25.261, lon: 51.565, country: 'QA' },
  BAH: { lat: 26.271, lon: 50.634, country: 'BH' },
  KWI: { lat: 29.227, lon: 47.969, country: 'KW' },
  MCT: { lat: 23.593, lon: 58.284, country: 'OM' },
  RUH: { lat: 24.958, lon: 46.699, country: 'SA' },
  JED: { lat: 21.680, lon: 39.157, country: 'SA' },
  TLV: { lat: 32.011, lon: 34.887, country: 'IL' },
  AMM: { lat: 31.723, lon: 35.993, country: 'JO' },
  BEY: { lat: 33.821, lon: 35.488, country: 'LB' },

  // Asia
  SIN: { lat: 1.350, lon: 103.994, country: 'SG' },
  BKK: { lat: 13.681, lon: 100.747, country: 'TH' },
  HKG: { lat: 22.309, lon: 113.915, country: 'HK' },
  NRT: { lat: 35.765, lon: 140.386, country: 'JP' },
  HND: { lat: 35.553, lon: 139.780, country: 'JP' },
  KIX: { lat: 34.434, lon: 135.232, country: 'JP' },
  ICN: { lat: 37.460, lon: 126.441, country: 'KR' },
  PEK: { lat: 40.080, lon: 116.585, country: 'CN' },
  PVG: { lat: 31.143, lon: 121.805, country: 'CN' },
  CAN: { lat: 23.393, lon: 113.299, country: 'CN' },
  CTU: { lat: 30.573, lon: 103.947, country: 'CN' },
  TPE: { lat: 25.078, lon: 121.233, country: 'TW' },
  KUL: { lat: 2.746, lon: 101.710, country: 'MY' },
  CGK: { lat: -6.126, lon: 106.656, country: 'ID' },
  DPS: { lat: -8.748, lon: 115.167, country: 'ID' },
  MNL: { lat: 14.509, lon: 121.020, country: 'PH' },
  CEB: { lat: 10.307, lon: 123.979, country: 'PH' },
  SGN: { lat: 10.819, lon: 106.652, country: 'VN' },
  HAN: { lat: 21.222, lon: 105.807, country: 'VN' },
  DEL: { lat: 28.556, lon: 77.100, country: 'IN' },
  BOM: { lat: 19.089, lon: 72.868, country: 'IN' },
  BLR: { lat: 13.199, lon: 77.706, country: 'IN' },
  MAA: { lat: 12.990, lon: 80.169, country: 'IN' },
  CCU: { lat: 22.654, lon: 88.447, country: 'IN' },
  CMB: { lat: 7.181, lon: 79.884, country: 'LK' },
  MLE: { lat: 4.192, lon: 73.529, country: 'MV' },
  KTM: { lat: 27.697, lon: 85.359, country: 'NP' },
  ISB: { lat: 33.617, lon: 73.099, country: 'PK' },
  KHI: { lat: 24.907, lon: 67.161, country: 'PK' },
  DAC: { lat: 23.843, lon: 90.398, country: 'BD' },
  RGN: { lat: 16.907, lon: 96.133, country: 'MM' },
  PNH: { lat: 11.546, lon: 104.844, country: 'KH' },

  // Oceania
  SYD: { lat: -33.946, lon: 151.177, country: 'AU' },
  MEL: { lat: -37.673, lon: 144.843, country: 'AU' },
  BNE: { lat: -27.384, lon: 153.117, country: 'AU' },
  PER: { lat: -31.940, lon: 115.967, country: 'AU' },
  AKL: { lat: -37.008, lon: 174.792, country: 'NZ' },
  CHC: { lat: -43.489, lon: 172.532, country: 'NZ' },
  NAN: { lat: -17.755, lon: 177.443, country: 'FJ' },

  // North America
  JFK: { lat: 40.640, lon: -73.779, country: 'US' },
  EWR: { lat: 40.693, lon: -74.169, country: 'US' },
  LAX: { lat: 33.943, lon: -118.408, country: 'US' },
  ORD: { lat: 41.978, lon: -87.904, country: 'US' },
  SFO: { lat: 37.619, lon: -122.375, country: 'US' },
  ATL: { lat: 33.637, lon: -84.428, country: 'US' },
  DFW: { lat: 32.897, lon: -97.038, country: 'US' },
  DEN: { lat: 39.862, lon: -104.673, country: 'US' },
  SEA: { lat: 47.449, lon: -122.309, country: 'US' },
  MIA: { lat: 25.793, lon: -80.291, country: 'US' },
  BOS: { lat: 42.365, lon: -71.010, country: 'US' },
  IAD: { lat: 38.953, lon: -77.456, country: 'US' },
  IAH: { lat: 29.984, lon: -95.342, country: 'US' },
  MSP: { lat: 44.882, lon: -93.222, country: 'US' },
  DTW: { lat: 42.212, lon: -83.353, country: 'US' },
  PHX: { lat: 33.437, lon: -112.008, country: 'US' },
  LAS: { lat: 36.080, lon: -115.152, country: 'US' },
  MCO: { lat: 28.429, lon: -81.309, country: 'US' },
  CLT: { lat: 35.214, lon: -80.943, country: 'US' },
  PHL: { lat: 39.872, lon: -75.241, country: 'US' },
  HNL: { lat: 21.319, lon: -157.925, country: 'US' },
  ANC: { lat: 61.174, lon: -149.996, country: 'US' },
  YYZ: { lat: 43.678, lon: -79.629, country: 'CA' },
  YVR: { lat: 49.195, lon: -123.179, country: 'CA' },
  YUL: { lat: 45.470, lon: -73.741, country: 'CA' },
  YYC: { lat: 51.122, lon: -114.013, country: 'CA' },
  MEX: { lat: 19.436, lon: -99.072, country: 'MX' },
  CUN: { lat: 21.037, lon: -86.877, country: 'MX' },
  GDL: { lat: 20.522, lon: -103.311, country: 'MX' },

  // Central America & Caribbean
  PTY: { lat: 9.071, lon: -79.384, country: 'PA' },
  SJO: { lat: 9.994, lon: -84.209, country: 'CR' },
  HAV: { lat: 22.989, lon: -82.409, country: 'CU' },
  SJU: { lat: 18.439, lon: -66.002, country: 'PR' },
  MBJ: { lat: 18.504, lon: -77.913, country: 'JM' },
  NAS: { lat: 25.039, lon: -77.466, country: 'BS' },
  PUJ: { lat: 18.567, lon: -68.363, country: 'DO' },

  // South America
  GRU: { lat: -23.432, lon: -46.470, country: 'BR' },
  GIG: { lat: -22.810, lon: -43.243, country: 'BR' },
  BSB: { lat: -15.870, lon: -47.921, country: 'BR' },
  EZE: { lat: -34.822, lon: -58.536, country: 'AR' },
  SCL: { lat: -33.393, lon: -70.786, country: 'CL' },
  BOG: { lat: 4.702, lon: -74.147, country: 'CO' },
  MDE: { lat: 6.164, lon: -75.423, country: 'CO' },
  LIM: { lat: -12.022, lon: -77.114, country: 'PE' },
  UIO: { lat: -0.129, lon: -78.359, country: 'EC' },
  CCS: { lat: 10.603, lon: -66.991, country: 'VE' },
  MVD: { lat: -34.838, lon: -56.031, country: 'UY' },

  // Africa
  JNB: { lat: -26.139, lon: 28.246, country: 'ZA' },
  CPT: { lat: -33.965, lon: 18.602, country: 'ZA' },
  CAI: { lat: 30.122, lon: 31.406, country: 'EG' },
  HRG: { lat: 27.178, lon: 33.799, country: 'EG' },
  SSH: { lat: 27.977, lon: 34.395, country: 'EG' },
  CMN: { lat: 33.367, lon: -7.590, country: 'MA' },
  RAK: { lat: 31.607, lon: -8.036, country: 'MA' },
  TUN: { lat: 36.851, lon: 10.227, country: 'TN' },
  ALG: { lat: 36.691, lon: 3.216, country: 'DZ' },
  NBO: { lat: -1.319, lon: 36.928, country: 'KE' },
  MBA: { lat: -4.035, lon: 39.594, country: 'KE' },
  DAR: { lat: -6.878, lon: 39.203, country: 'TZ' },
  ADD: { lat: 8.978, lon: 38.799, country: 'ET' },
  LOS: { lat: 6.577, lon: 3.321, country: 'NG' },
  ABJ: { lat: 5.261, lon: -3.926, country: 'CI' },
  ACC: { lat: 5.605, lon: -0.167, country: 'GH' },
  DSS: { lat: 14.740, lon: -17.490, country: 'SN' },
  MRU: { lat: -20.430, lon: 57.684, country: 'MU' },
  SEZ: { lat: -4.674, lon: 55.522, country: 'SC' },
  ZNZ: { lat: -6.222, lon: 39.225, country: 'TZ' },
};

export function getCoords(iata: string): { lat: number; lon: number } | null {
  const c = COORDS[iata];
  return c ? { lat: c.lat, lon: c.lon } : null;
}

/** Return all IATA codes and their coordinates (for proximity searches) */
export function allAirportCoords(): { iata: string; lat: number; lon: number }[] {
  return Object.entries(COORDS).map(([iata, c]) => ({ iata, lat: c.lat, lon: c.lon }));
}

export function getCountry(iata: string): string | null {
  return COORDS[iata]?.country ?? null;
}

/** Haversine great-circle distance in nautical miles */
export function greatCircleDistance(
  from: { lat: number; lon: number },
  to: { lat: number; lon: number },
): number {
  const R = 3440.065; // Earth radius in nm
  const dLat = toRad(to.lat - from.lat);
  const dLon = toRad(to.lon - from.lon);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(from.lat)) * Math.cos(toRad(to.lat)) * Math.sin(dLon / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(a));
}

/** Rough estimate: nm / 450 average cruise speed */
export function estimateFlightHours(nm: number): number {
  return nm / 450;
}

function toRad(deg: number): number {
  return (deg * Math.PI) / 180;
}
